import './TrendIndicator.css';

export function TrendIndicator({ value, tone = 'neutral' }: { value: string; tone?: 'good' | 'warning' | 'attention' | 'neutral' }) {
  return (
    <span className="trend-indicator numeric" data-tone={tone}>
      {value}
    </span>
  );
}
